import { Reveal } from "@/components/Reveal";
import { SectionHeader } from "@/components/SectionHeader";
import { EDUCATION } from "@/data/content";
import { GraduationCap, MapPin } from "lucide-react";

export const Education = () => (
    <section id="education" data-testid="education-section" className="scroll-mt-20 border-t border-white/5 bg-surface/30 py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <SectionHeader
                chapter="06"
                kicker="Foundation"
                title="Education"
                testId="education-heading"
            />

            <Reveal>
                <article
                    data-testid="education-card"
                    className="border border-white/10 bg-surface/70 p-8 transition-[border-color,box-shadow] duration-500 hover:border-neon/30 md:p-10"
                >
                    <div className="flex flex-wrap items-start justify-between gap-4">
                        <div>
                            <div className="mb-3 flex items-center gap-3">
                                <span className="flex h-10 w-10 items-center justify-center border border-neon/30 bg-neon/5 text-neon">
                                    <GraduationCap size={17} strokeWidth={1.5} />
                                </span>
                                <span className="border border-white/10 bg-black/30 px-3 py-1 font-mono2 text-xs text-zinc-400">
                                    {EDUCATION.period}
                                </span>
                            </div>
                            <h3 className="font-display text-2xl font-extrabold tracking-tighter text-zinc-100 sm:text-3xl">
                                {EDUCATION.degree}
                            </h3>
                            <p className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 font-mono2 text-sm text-zinc-400">
                                <span className="text-neon">{EDUCATION.school}</span>
                                <span className="flex items-center gap-1.5 text-zinc-500">
                                    <MapPin size={13} strokeWidth={1.5} />
                                    {EDUCATION.location}
                                </span>
                            </p>
                        </div>
                    </div>

                    <p className="mt-8 font-mono2 text-xs uppercase tracking-[0.25em] text-zinc-500">
                        Relevant Coursework
                    </p>
                    <ul className="mt-4 flex flex-wrap gap-2">
                        {EDUCATION.coursework.map((course) => (
                            <li
                                key={course}
                                data-testid={`coursework-${course.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                className="cursor-default border border-white/10 bg-black/30 px-3 py-1.5 font-mono2 text-xs text-zinc-300 transition-[border-color,color,background-color] duration-300 hover:border-neon/50 hover:bg-neon/5 hover:text-neon"
                            >
                                {course}
                            </li>
                        ))}
                    </ul>
                </article>
            </Reveal>
        </div>
    </section>
);
